var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimezoneLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C16.4183 2 20 5.58172 20 10C20 16.4183 12 22 12 22C12 22 4 16.4183 4 10C4 5.58172 7.58172 2 12 2ZM12 4C8.68629 4 6 6.68629 6 10C6 12.4318 7.56076 14.9521 9.47949 17.0605C10.3888 18.0598 11.304 18.8854 12 19.4658C12.696 18.8854 13.6112 18.0598 14.5205 17.0605C16.4392 14.9521 18 12.4318 18 10C18 6.68629 15.3137 4 12 4Z",
    fill: "#045694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.7998C12.2761 7.7998 12.4999 8.02375 12.5 8.2998L12.5 9.79297L13.5557 10.8486C13.7509 11.0439 13.7509 11.3604 13.5557 11.5557C13.3604 11.7509 13.0439 11.7509 12.8486 11.5557L11.6465 10.3535C11.549 10.2559 11.5001 10.1279 11.5 10V8.2998C11.5001 8.02375 11.7239 7.7998 12 7.7998Z",
    fill: "#045694"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.5C14.4853 5.5 16.5 7.51472 16.5 10C16.5 12.4853 14.4853 14.5 12 14.5C9.51472 14.5 7.5 12.4853 7.5 10C7.5 7.51472 9.51472 5.5 12 5.5ZM12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 11.933 10.067 13.5 12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.067 13.933 6.5 12 6.5Z",
    fill: "#045694"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezoneLocation);
export default __webpack_public_path__ + "static/media/TimezoneLocation.b7fb9914dd0cc3dd7ab36e041ba35508.svg";
export { ForwardRef as ReactComponent };